module.exports = __webpack_public_path__ + "static/media/EuclidCircularB-Semibold.91208401.woff2";